import { render } from "./widgetTitleBar.vue?vue&type=template&id=1caadc36&scoped=true"
import script from "./widgetTitleBar.vue?vue&type=script&lang=js"
export * from "./widgetTitleBar.vue?vue&type=script&lang=js"

import "./widgetTitleBar.vue?vue&type=style&index=0&id=1caadc36&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1caadc36"]])

export default __exports__